var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_18591_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.191162 13.5908C-0.177375 15.7413 0.412688 17.96 1.30585 19.7511V19.7634C1.9512 21.0641 2.8332 22.0916 3.83779 23.1096L9.90527 20.8106C8.75734 20.2051 8.58218 19.834 7.7593 19.157C6.91839 18.2764 6.29165 17.2655 5.90134 16.0802H5.88562L5.90134 16.0679C5.64457 15.2852 5.61924 14.4543 5.60977 13.5908H-0.191162Z",
    fill: "url(#paint0_radial_18591_5840)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_18591_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2772 -0.0976562C12.6775 2.09024 12.9068 4.21694 13.2772 5.45435C13.9697 5.45488 14.6368 5.54061 15.2694 5.71139C16.7196 6.10291 17.7453 6.87402 18.3738 7.48395L22.2636 3.52832C19.9593 1.33428 17.1862 -0.0941994 13.2772 -0.0976562Z",
    fill: "url(#paint1_radial_18591_5840)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_18591_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2642 -0.115234C10.3226 -0.1153 7.60682 0.836466 5.38131 2.44498C4.55498 3.04223 3.79667 3.73214 3.12144 4.49934C2.94455 6.22269 4.44562 8.34086 7.41821 8.32332C8.86048 6.5811 10.9936 5.45388 13.3677 5.45388C13.3699 5.45388 13.372 5.45406 13.3742 5.45407L13.2772 -0.11484C13.2728 -0.114843 13.2686 -0.115234 13.2642 -0.115234Z",
    fill: "url(#paint2_radial_18591_5840)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_18591_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.973 14.2146L20.3474 16.0877C20.2322 16.8223 19.9733 17.5449 19.5944 18.2038C19.1604 18.9587 18.6238 19.5335 18.0738 19.9712C16.4296 21.2795 14.5138 21.5489 13.1801 21.55C11.8017 23.9881 11.56 25.2093 13.2771 27.1771C15.4018 27.1755 17.2855 26.7772 18.947 26.0313C20.1481 25.4921 21.2122 24.7889 22.1756 23.8851C23.4486 22.6909 24.4458 21.2137 25.1263 19.5143C25.8068 17.8148 26.1707 15.8931 26.1707 13.8096L22.973 14.2146Z",
    fill: "url(#paint3_radial_18591_5840)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_18591_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0833 10.7988V16.3835H25.7155C25.8266 15.6187 26.1941 14.629 26.1941 13.8096C26.1941 12.8521 26.1015 11.6826 25.9445 10.7988H13.0833Z",
    fill: "#3086FF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_18591_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18163 4.30176C2.40209 5.18748 1.73612 6.17887 1.20808 7.25103C0.302179 9.08468 -0.193848 11.3139 -0.193848 13.4987C-0.193848 13.5295 -0.191394 13.5596 -0.191196 13.5903C0.210002 14.3892 5.35063 14.2362 5.60973 13.5903C5.60941 13.5602 5.60614 13.5308 5.60614 13.5006C5.60614 12.6045 5.75192 11.944 6.01765 11.1339C6.34546 10.1346 6.85875 9.21433 7.51509 8.42147C7.66388 8.22422 8.06074 7.80015 8.17653 7.54579C8.22064 7.4489 8.09645 7.39452 8.08951 7.36042C8.08174 7.32228 7.91525 7.35295 7.87794 7.32454C7.75951 7.23433 7.52499 7.18722 7.38258 7.14535C7.07819 7.05584 6.57373 6.85847 6.29354 6.65387C5.40787 6.00713 4.02569 5.2346 3.18163 4.30176Z",
    fill: "url(#paint4_radial_18591_5840)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_18591_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31262 7.36491C8.36641 8.65685 8.95704 6.7128 10.3225 6.10446L7.94722 0.989258C7.07345 1.37063 6.24791 1.84444 5.48194 2.39805C4.33803 3.22483 3.32787 4.23374 2.49341 5.38189L6.31262 7.36491Z",
    fill: "url(#paint5_radial_18591_5840)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_18591_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14839 20.4156C4.39144 21.4492 3.95983 21.4862 3.70605 23.2605C4.19101 23.752 4.71206 24.2066 5.26575 24.6187C6.75148 25.7247 9.60938 27.1977 13.2644 27.1977C13.2687 27.1977 13.2728 27.1973 13.2771 27.1973V21.4514C13.2743 21.4514 13.2711 21.4516 13.2683 21.4516C11.8997 21.4516 10.806 21.0783 9.68459 20.4291C9.40811 20.269 8.90649 20.6988 8.6515 20.5067C8.29981 20.2417 7.45343 20.735 7.14839 20.4156Z",
    fill: "url(#paint6_radial_18591_5840)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_18591_5840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6626 21.2705V27.0978C12.174 27.16 12.7062 27.1978 13.2645 27.1978C13.8242 27.1978 14.3657 27.1679 14.8918 27.113V21.3098C14.3022 21.4145 13.7469 21.4517 13.2685 21.4517C12.7175 21.4517 12.1818 21.3851 11.6626 21.2705Z",
    fill: "url(#paint7_linear_18591_5840)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_18591_5840",
    x: -0.661241,
    y: 13.1207,
    width: 11.0366,
    height: 10.4587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_18591_5840"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_18591_5840",
    x: 12.4384,
    y: -0.567736,
    width: 10.2954,
    height: 8.52219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_18591_5840"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_18591_5840",
    x: 2.63734,
    y: -0.585314,
    width: 11.207,
    height: 9.37864,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_18591_5840"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_18591_5840",
    x: 11.5971,
    y: 13.3395,
    width: 15.0437,
    height: 14.3073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_18591_5840"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_18591_5840",
    x: 12.6132,
    y: 10.3287,
    width: 14.051,
    height: 6.52512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_18591_5840"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_18591_5840",
    x: -0.663927,
    y: 3.83168,
    width: 9.32004,
    height: 10.7722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_18591_5840"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_18591_5840",
    x: -0.811442,
    y: -2.31559,
    width: 14.4388,
    height: 13.4193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65243,
    result: "effect1_foregroundBlur_18591_5840"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_18591_5840",
    x: 3.23598,
    y: 19.9225,
    width: 10.5112,
    height: 7.74485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_18591_5840"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_18591_5840",
    x: 11.1925,
    y: 20.8004,
    width: 4.16941,
    height: 6.86789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.23504,
    result: "effect1_foregroundBlur_18591_5840"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18591_5840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.78381 22.9071) rotate(-92.301) scale(13.4568 19.4421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141612,
    stopColor: "#1ABD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247515,
    stopColor: "#6EC30D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#8AC502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#A2C600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445673,
    stopColor: "#C8C903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#EBCB03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#F7CD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699345,
    stopColor: "#FDCD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FDCE05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FFCE0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_18591_5840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8997 7.19774) scale(9.17547 12.0479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408458,
    stopColor: "#FB4E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4540"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_18591_5840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8889 -1.85921) rotate(150.615) scale(14.7537 20.1957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#FF4541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#FF4540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF4640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FF473F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#FF5138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FF5B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FF6C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_18591_5840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4682 25.4296) rotate(-126.996) scale(38.7426 14.2374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131546,
    stopColor: "#0CBA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209784,
    stopColor: "#0BB86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297297,
    stopColor: "#09B479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396257,
    stopColor: "#08AD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477124,
    stopColor: "#0AA6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568425,
    stopColor: "#0D9CC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667385,
    stopColor: "#1893DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768727,
    stopColor: "#258BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858506,
    stopColor: "#3086FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_18591_5840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1378 2.4344) rotate(96.5098) scale(14.5525 19.7988)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#FF4E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#FF8A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#FFA312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615636,
    stopColor: "#FFB60C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#FECF0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#FECF08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCD01"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_18591_5840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.81775 2.2851) rotate(131.647) scale(7.1764 20.2049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315904,
    stopColor: "#FF4C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603818,
    stopColor: "#FF692C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726837,
    stopColor: "#FF7825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884534,
    stopColor: "#FF8D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F13"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_18591_5840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8888 28.8596) rotate(-150.615) scale(14.7537 20.1957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231273,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311547,
    stopColor: "#0FBC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366013,
    stopColor: "#0FBC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457516,
    stopColor: "#0FBC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540305,
    stopColor: "#12BC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699346,
    stopColor: "#28BF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771242,
    stopColor: "#38C02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860566,
    stopColor: "#52C218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915033,
    stopColor: "#67C30F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86C504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18591_5840",
    x1: 11.6626,
    y1: 24.2341,
    x2: 14.8918,
    y2: 24.2341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FBC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBA65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.201d68b14b45a106d74793bf68f33e68.svg";
export { ForwardRef as ReactComponent };